// Libs
import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
  CrfAreaExecutiveSummaryCurvaEconomicaResult,
  CrfAreaExecutiveSummaryResult, CrfAreaExecutiveSummaryTipoProjetoForecastResult,
  CrfGraficoAreaExecutiveSummaryResumoCapExResult,
  CrfGraficoTipoPacote,
  getCrfAreaExecutiveSummaryByUserId
} from '@app/api/crf/areaExecutiveSummary';

//Files
import AreaExecutiveSummaryTipoPacote from './areaExecutiveSummaryTipoPacote';
import AreaExecutiveSummaryTipoProjetoForecast from './areaExecutiveSummaryTipoProjetoForecast';
import AreaExecutiveSummaryResumoCapEx from './areaExecutiveSummaryResumoCapEx';
import AreaExecutiveSummaryCurvaEconomica from './areaExecutiveSummaryCurvaEconomica';
import FiltroPesquisaAreaExecutiveSummary from './filtroPesquisaAreaExecutiveSummary';

//Utils
import ptBr from '@app/i18n/ptBR/index';
import { formatCurrencyBr } from '@app/helpers/numbers'
import { hasPermission } from '@app/helpers/permissions';

export interface CrfAreaExecutiveSummaryProps {
  fechamentoId?: string;
  telaInicial: boolean;
}

const CrfAreaExecutiveSummary = ({ fechamentoId, telaInicial }: CrfAreaExecutiveSummaryProps) => {

  const [areaExecutiveSummaryResult, setAreaExecutiveSummaryResult] = useState<CrfAreaExecutiveSummaryResult>(
    {} as CrfAreaExecutiveSummaryResult,
  );

  useEffect(() => {
    getCrfAreaExecutiveSummaryByUserId({ fechamentoId: fechamentoId, telaInicial: telaInicial }).then(areaExecutiveSummary => {
      if (areaExecutiveSummary) {
        tratarValoreDashboardAreaExecutiveSummary(areaExecutiveSummary);
      }
    });
  }, []);

  const tratarValoreDashboardAreaExecutiveSummary = (areaExecutiveSummary: CrfAreaExecutiveSummaryResult) => {
    if (areaExecutiveSummary.graficoCurva) {

      areaExecutiveSummary.graficoCurva.series.forEach((serie) => {
        if (serie.data) {
          for (var i = 0; i <= 11; i++) {
            if (serie.data[i] <= 0) {
              serie.data[i] = null;
            }
          }
        }
      });

      if (areaExecutiveSummary.graficoCurva.tableDataSource
        && areaExecutiveSummary.graficoCurva.collunsTable) {

        areaExecutiveSummary.graficoCurva.tableDataSource.forEach((tabela) => {
          areaExecutiveSummary.graficoCurva.collunsTable.forEach((colunaTabela) => {
            if (tabela[colunaTabela.dataIndex] <= 0) {
              tabela[colunaTabela.dataIndex] = null;
            }
          });
        });
      }

    }

    setAreaExecutiveSummaryResult(areaExecutiveSummary);
  }

  const filtroAreaExecutiveSummary = () => {
    return <>
      {hasPermission(['FILTRO_PESQUISA_AREA_EXECUTIVE_SUMMAY']) && (
        <FiltroPesquisaAreaExecutiveSummary
          tratarValoreDashboardAreaExecutiveSummary={tratarValoreDashboardAreaExecutiveSummary}
          fechamentoId={fechamentoId}
          telaInicial={telaInicial}
        />
      )}
    </>
  }

  const widgetAreaExecutiveSummary = () => {
    return <ui.Widget
      className="area-executive-summary"
      title={[
        <div className="area-executive-summary-title">
          <div>
            {ptBr.diretoria}: {areaExecutiveSummaryResult.siglaDiretoria}
          </div>
          <div>
            {ptBr.area}: {areaExecutiveSummaryResult.siglaArea}
          </div>
          <div>
            {ptBr.departamento}: {areaExecutiveSummaryResult.siglaDepartamento}{' '}
          </div>
        </div>,
      ]}
      span={12}
      actions={[]}>
      <Row>
        <Col span={12} className="area-executive-summary-col">
          <Row>
            <Col span={12}>
              <Card
                className="card-area-executive-summary ant-card-gerencia"
                title={areaExecutiveSummaryResult.descricaoDiretoria}
                bordered={false}
                style={{ height: 205 }}>
                <span>{areaExecutiveSummaryResult.mesAno}</span>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                className="card-area-executive-summary numero-simples"
                title={ptBr.totalProjeto}
                bordered={false}
                style={{ height: 205 }}>
                <span>{areaExecutiveSummaryResult.totalProjeto}</span>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Card
                className="card-area-executive-summary numero-simples"
                title={ptBr.naoPrevisto}
                bordered={false}
                style={{ height: 205 }}>
                <span>{areaExecutiveSummaryResult.naoPrevisto}</span>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                className="card-area-executive-summary valor-financeiro"
                title={ptBr.orcadoAno}
                bordered={false}
                style={{ height: 205 }}>
                <span>{formatCurrencyBr(areaExecutiveSummaryResult.orcadoAno)}</span>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Card
                className="card-area-executive-summary valor-financeiro"
                title={ptBr.forecastAno}
                bordered={false}
                style={{ height: 205 }}>
                <span>{formatCurrencyBr(areaExecutiveSummaryResult.forecastAno)}</span>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                className="card-area-executive-summary valor-financeiro"
                title={ptBr.variacao}
                bordered={false}
                style={{ height: 205 }}>
                <span>{formatCurrencyBr(areaExecutiveSummaryResult.variacao)}</span>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Card title={ptBr.tiposDePacote} bordered={false} className="card-area-executive-summary-grafico">
            <AreaExecutiveSummaryTipoPacote
              graficoPacote={
                areaExecutiveSummaryResult
                  ? areaExecutiveSummaryResult.graficoTipoPacote
                  : ({} as CrfGraficoTipoPacote)
              }
            />
          </Card>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Card
            title={ptBr.tipoDeProjetoForecast}
            bordered={false}
            className="card-area-executive-summary-grafico"
          >
            <AreaExecutiveSummaryTipoProjetoForecast
              graficoResult={areaExecutiveSummaryResult ?
                areaExecutiveSummaryResult.tipoProjetoForecast :
                {} as CrfAreaExecutiveSummaryTipoProjetoForecastResult}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card
            title={ptBr.buildUpR$M}
            bordered={false}
            className="card-area-executive-summary-grafico"
          // style={{ height: 300 + 'px', width: 600 + 'px' }}
          >
            <AreaExecutiveSummaryResumoCapEx
              grafico={areaExecutiveSummaryResult
                && areaExecutiveSummaryResult.resumoCapEx
                ? areaExecutiveSummaryResult.resumoCapEx :
                {} as CrfGraficoAreaExecutiveSummaryResumoCapExResult}
            />
          </Card>

        </Col>

      </Row>


      <Row>
        <Col span={24}>
          <Card
            className="card-area-executive-summary-grafico"
          >
            <AreaExecutiveSummaryCurvaEconomica
              grafico={areaExecutiveSummaryResult ?
                areaExecutiveSummaryResult.graficoCurva :
                {} as CrfAreaExecutiveSummaryCurvaEconomicaResult}
            />
          </Card>
        </Col>

      </Row>
    </ui.Widget>
  }

  return (
    <>
      {telaInicial ?
        widgetAreaExecutiveSummary()
        :
        <ui.SimpleView>
          <ui.GridView noform>
            {filtroAreaExecutiveSummary()}
            {widgetAreaExecutiveSummary()}
          </ui.GridView>
        </ui.SimpleView>
      }
    </>
  );
};

export default CrfAreaExecutiveSummary;
